import { connect } from 'react-redux';

import { getSecondHandBoardgames } from '../actions/secondHandBoardgames';

import {
  unsoldBoardgamesSelector,
  loadingSelector,
} from '../reducers/secondHandBoardgames';

import SecondHandBoardgamesListPageComponent from '../components/SecondHandBoardgamesListPage';

const mapStateToProps = state => {
  return {
    boardgames: unsoldBoardgamesSelector(state),
    loading: loadingSelector(state),
  };
};

const mapDispatchToProps = dispatch => {
  return { 
    getSecondHandBoardgames: () => dispatch(getSecondHandBoardgames()),
  };
};

const SecondHandBoardgamesListPage = connect(mapStateToProps, mapDispatchToProps)(SecondHandBoardgamesListPageComponent);

export default SecondHandBoardgamesListPage;

